import { useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import SEARCH_QUERY from '../queries/SEARCH_QUERY';
import parseSearchQueryData from '../dataParsing/searchQueryDataParser';

const useSearch = ( { type = 'notifications', fetchPolicy = 'network-only' } ) => {

    const DEFAULT_VARIABLES = {
        variables: {
            types: [ type ],
            query: '',
            page: 1,
            limit: 10, 
            sort: 'name',
            order: 'asc',
            objectExcludeFormats: type === 'objects' ? [ 'ilt' ] : []
        }, 
        fetchPolicy
    };

    const [ dataCount, setDataCount ] = useState( 0 );
    const [ queryVariables, setQueryVariables ] = useState( JSON.parse( JSON.stringify( DEFAULT_VARIABLES ) ) );
    const [ fetchSearch, { data, loading, error } ] = useLazyQuery( SEARCH_QUERY, queryVariables );

    const searchData = useMemo( () => {
        if ( data?.search?.edges ) {
            setDataCount( data?.search?.totalCount || 0 );
            return parseSearchQueryData( { type, data } );
        } 

        return [];
    }, [ data ] );
 
    const loadSearch = ( { searchText, currentPage = 1, sortField = 'name', 
        sortDirection = 'ascend', brandsFilter, searchIds, limit = 10 } ) => {
        const vars = JSON.parse( JSON.stringify( DEFAULT_VARIABLES ) );
        
        vars.variables.limit = limit;

        if ( currentPage ) {
            vars.variables.page = currentPage;
        }
        
        if ( sortField ) {
            vars.variables.sort =  sortField;
        }

        if ( sortDirection ) {
            vars.variables.order = sortDirection === 'ascend' ? 'asc' : sortDirection === 'descend' ? 'desc' : '';
        }
        
        if ( searchText ) {
            vars.variables.query = searchText;
            vars.variables.sort = '_score';
            vars.variables.order = 'desc';
        }
         
        if ( searchIds ) {
            vars.variables._ids = searchIds;
        }

        if ( brandsFilter ) {
            vars.variables.brandIds = brandsFilter.split( ',' );
        }

        setQueryVariables( vars );
        fetchSearch();
    };

    return useMemo( () => {
        return {
            searchData,
            searchDataCount: dataCount,
            searchError: error,
            searchLoading: loading,
            loadSearch,
        };
    }, [ searchData, dataCount, error, loading ] );
};

export default useSearch;
